<template>
  <el-dialog title="分配" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="技术老师：" prop="customerAddDTO.technicianId" class="width100" :rules="[{required:true,message: '请选择技术老师',trigger: 'change'}]">
        <el-select v-model="form.customerAddDTO.technicianId" placeholder="请选择技术老师" filterable :filter-method="technicianFilter" clearable @blur="getTechnicianList({...addr,realName:''})">
          <el-option :label="`${item.realName}（${item.levelName}）${item.mobile}`" :value="item.id" v-for="item in technicianList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import clientListApi from '@/api/client/clientList'
  import technicianInfoApi from '@/api/technical/technicianInfo'
function initFormBean() {
  const formBean = {
    customerAddDTO:{
       technicianId: null,
    }
  }
  return formBean
}

export default {
  props: {

  },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      selectItems:[],
      popType:null,
      technicianList:[],
      addr:{},
      isLoading:false
    }
  },
  created() {

  },
  methods: {
    technicianFilter(e){
      // console.log('e',e)
      this.getTechnicianList({...this.addr,realName:e})
    },
    // 获取技术老师列表
    getTechnicianList({areaProvinceCode,areaCityCode,areaDistrictCode,realName}) {
      let obj={
        isGetAllParent: true,
        status:10,
        levelIdSortSign:1,
        areaProvinceCode,
        areaCityCode,
        areaDistrictCode,
        realName,
        pageNo:1,
        pageSize:100,
      }
      // if(realName){
        // obj.realName=realName
      // }
      technicianInfoApi.listPageForMini(obj).then(({
        data
      }) => {
        this.technicianList = data.list
        // console.log('技术老师列表: ',data);
      })
    },
    resetForm() {
      this.form = initFormBean()
    },
    handleCreate({row,type}) {
      this.resetForm()
      this.popType=type*1
      if(this.popType){
        this.form.customerAddDTO = row.customer
        this.form.customerAddDTO.technicianId=null
        if(row.addr && row.addr.length){
          this.addr={
            areaProvinceCode:row.addr[0].regionCode,areaCityCode:row.addr[1].regionCode,areaDistrictCode:row.addr[2] && row.addr[2].regionCode
          }
        }
        this.getTechnicianList({...this.addr})
      }else{
        this.selectItems=row
      }
      // this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true
          let arr=[]
          if(this.popType){
            arr=[{
            id: this.form.customerAddDTO.id,
            parentId: this.form.customerAddDTO.parentId,
            customerType: this.form.customerAddDTO.customerType,
            technicianId: this.form.customerAddDTO.technicianId,
            isOpenSea:0,
            dataCompareLogType2:15
          }]
          }else{
            // console.log('this.selectItems: ',this.selectItems);
            arr=this.selectItems.map(item=>({id:item.customer.id,parentId: item.customer.parentId,
            customerType: item.customer.customerType,
            dataCompareLogType2:15,
            isOpenSea:0,
            technicianId: item.customer.technicianId}))
          }
          // console.log('arr: ',arr);
          // return
         clientListApi.updateSuperiors(arr).then((data) => {
           this.postCallback(data)
         }).catch(res=>{
                this.isLoading=false
              });
        }
      });
    },
    postCallback(data) {
      this.$message.success('提交成功！您的任务已开始执行，请耐心等待。您可以前往任务表查看进度')
      this.formVisible = false;
      this.$emit('created')
      this.isLoading=false
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
</style>
